module.exports = require('./_shared')('native-function-to-string', Function.toString);



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_function-to-string.js